import { useAppSelector } from '@/shared/store/hooks';
import { isClientRole } from '@/shared/config/roles';

/** True when the signed-in user is an agency CLIENT account. */
export function useIsClient(): boolean {
  const role = useAppSelector((s) => s.auth.user?.role);
  return isClientRole(role);
}
